import { useQuery } from "react-query";
import axios from "axios";
import { setHeaders } from "../../../utils/basic";
import * as config from "../../../app.config";

const getReportDtlById = async (rptuid) => {

    const headerConfig = setHeaders();

    const { data } = await axios
        .get(`${config.ENDPOINTS["datalake"]}/display/mfg_report/${rptuid}`, {
            headers: headerConfig
        });

    return data;
};

export default function useFetchRptDetailByRptId(rptuid) {
    return useQuery(["mfgrptbyid", rptuid], () => getReportDtlById(rptuid), {

        onSuccess: (data) => {

        },
        onError: (error) => {
            console.log(error);
        }

    });
}